import { defineMessages } from "react-intl";

export function frenchArticleVars(clientName: string) {
  const match = clientName.match(/^([Ll](?:es?|a)) (.*)/);
  if (!match) return { articleType: "none", clientBaseName: clientName };
  return { articleType: match[1].toLowerCase(), clientBaseName: match[2] };
}

export const translateOutOfReactScopeMessages = (messages: {
  [messageKey: string]: string;
}): void => {
  translateNoScript(messages.noScript);
};

const translateNoScript = (text?: string): void => {
  if (!text) return;
  const element = document.getElementsByTagName("noscript")[0];
  if (element.textContent) element.textContent = text;
  else if (element.innerHTML) element.innerHTML = text;
};

defineMessages({
  noScript: {
    id: "noScript",
    defaultMessage: "You need to enable JavaScript to run this app.",
  },
});
